import { Outlet } from 'react-router-dom';
import "./NavigationBar/LoggedNavigation/LoggedCss.css";

export default function Content() {
  return (
    
      <Outlet />
    
  );
}